import axios from '@/plugins/axios';
import utils from '@/stores/utils';

const state = {
    stockproduct: null,
};


const mutations = {
    updateStockProduct(state, stockproduct) {
        state.stockproduct = stockproduct;
    },
};

const actions = {

    async saveStockLocation({ commit, dispatch, state }, params) {

        let url = '/api/stockproducts/';
        let method = axios.post;
        let payload = params.stockproduct;

        if (params.stockproduct.id) {
            url = `/api/stockproducts/${params.stockproduct.id}/`;
            method = axios.patch;
            payload = {
                location: params.stockproduct.location
            }
        }

        try {
            const response = await method(url, payload);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
